import type {
  GlobalCustomersAddressFormatDto,
  GlobalCustomersAddressFormatLineDto,
  GlobalCustomersAddressFormatLineDtoFieldsItem,
  GlobalSharedAddressDto,
} from '@ori/global-api-client-react';
import type {
  StaticCustomersMetadataAddressPropertyDto,
  StaticCustomersMetadataRegistrationAddressMetadataDto,
} from '@ori/static-api-client-react';

export const getCorrectFieldsForValidate = (
  fieldsConfig?: StaticCustomersMetadataRegistrationAddressMetadataDto,
): string[] => {
  const resultFields: string[] = [];

  if (fieldsConfig) {
    Object.entries(fieldsConfig).forEach((field: [string, StaticCustomersMetadataAddressPropertyDto]) => {
      if (field[1].isAvailable && field[1].validation?.isAddressMatchRequired) {
        resultFields.push(field[0]);
      }
    });
  }

  return resultFields;
};

export const getOptionLabelSingleLine = (
  lineNumber: number,
  item: GlobalSharedAddressDto,
  addressFormat: GlobalCustomersAddressFormatDto,
): string => {
  if (addressFormat.lines[lineNumber]) {
    const { fields, separators } = addressFormat.lines[lineNumber] as GlobalCustomersAddressFormatLineDto;
    let result = '';

    fields.forEach((field: string, idx: number) => {
      const correctField = field.charAt(0).toLowerCase() + field.slice(1);

      if (correctField === 'zipCode') {
        result += `${item.zipcode}${separators[idx + 1]}`;
      } else {
        const newField = item[correctField as keyof GlobalSharedAddressDto];
        if (newField && newField !== '') {
          result += `${newField}${separators[idx + 1]}`;
        }
      }
    });

    return `${separators[0]}${result}${separators.at(-1)}`;
  }

  return item.streetAddress ?? '';
};

type LowerCaseStreetAddressGlobalCustomersAddressFormatLineDtoFieldsItem = 'streetAddress';

export const defaultAddressFormat: GlobalCustomersAddressFormatDto = {
  type: 'SingleLine',
  lines: [
    {
      fields: ['streetAddress'] as GlobalCustomersAddressFormatLineDtoFieldsItem &
        LowerCaseStreetAddressGlobalCustomersAddressFormatLineDtoFieldsItem,
      separators: ['', ''],
    },
  ],
};
